import { useEffect, useState } from 'react';
import { publicSubscriptionsAPI } from '../services/api';
import { normalizePlans } from '../data/normalizePlans';

export const usePublicPlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    publicSubscriptionsAPI
      .getPlans()
      .then((res) => {
        if (!mounted) return;
        const list = res.data?.data ?? res.data ?? [];
        setPlans(normalizePlans(list));
      })
      .catch((err) => {
        if (mounted) setError(err);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return { plans, loading, error };
};

export default usePublicPlans;
